import { useCallback, useMemo } from 'react';

import { ButtonMantine, ButtonProps } from 'ui';

import type { EventTicketInfo } from './eventTicketsPdf.types';
import { useCreateTicketPdf } from './useCreateTicketPdf';

interface EventTicketsPrintButtonProps extends Pick<EventTicketInfo, 'title'> {
  eventStartDate?: string;
  venueName?: string;
  addressLineOne?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  eventList: EventTicketInfo[];
  buttonProps?: ButtonProps;
}

const EventTicketsPrintButton = ({
  title,
  eventStartDate,
  venueName,
  addressLineOne,
  city,
  state,
  zipCode,
  eventList,
  buttonProps,
}: EventTicketsPrintButtonProps) => {
  const ticketLocationString = useMemo(() => {
    return [venueName, addressLineOne, city, state, zipCode].filter(Boolean).join(', ');
  }, [venueName, addressLineOne, city, state, zipCode]);

  const { createTicketPdf, isLoading } = useCreateTicketPdf({
    eventName: title,
    eventStartDate,
    location: ticketLocationString,
  });

  const handleDownloadTicket = useCallback(() => {
    void createTicketPdf(eventList);
  }, [createTicketPdf, eventList]);

  const buttonText = useMemo(() => {
    return eventList.length === 1 ? 'Download Ticket' : 'Download All Tickets';
  }, [eventList]);

  if (eventList.length === 0) {
    return null;
  }

  return (
    <ButtonMantine onClick={handleDownloadTicket} loading={isLoading} {...buttonProps}>
      {buttonText}
    </ButtonMantine>
  );
};

export { EventTicketsPrintButton };
